export default Object.freeze({
  AzureGraph: 1,
});
